import moment from 'moment';
import {formatCurrency, translate} from 'views/module';

const DAY_LABEL = {
  MO: translate('timeFormat.DaysOfTheWeek.Monday'),
  TU: translate('timeFormat.DaysOfTheWeek.Tuesday'),
  WE: translate('timeFormat.DaysOfTheWeek.Wednesday'),
  TH: translate('timeFormat.DaysOfTheWeek.Thursday'),
  FR: translate('timeFormat.DaysOfTheWeek.Friday'),
  SA: translate('timeFormat.DaysOfTheWeek.Saturday'),
  SU: translate('timeFormat.DaysOfTheWeek.Sunday'),
};

const parseJobData = (job) => {
  const currency = 'CAD';
  const hourlyRate = job.price.hourlyRate;
  const formatedHourlyRate = formatCurrency(hourlyRate, currency, 'en-CA');
  const payPerHour = translate('jobBoard.SalaryDetails.PayPerHour', {
    currency: currency,
    formatedHourlyRate: formatedHourlyRate,
  });
  const recurrenceType = job.schedule.type;
  const scheduleStringsFormated = [];
  let hoursPerWeek = 0;
  let weeklyRate = 0;
  let numShifts = 0;
  let hoursPerWeekString = '';
  let shifts = '';
  let salaryInfo = payPerHour;
  switch (recurrenceType) {
    case 'RECURRENCE_EVENT':
      const weeklySlots = job.schedule.recurrenceRule.weeklySlots;
      // Calculate salary info to display
      hoursPerWeek = weeklySlots.reduce((totalHours, slot) => {
        const startTime = moment(slot.startTime);
        const endTime = moment(slot.endTime);
        const duration = moment.duration(endTime.diff(startTime));
        // format and get the schedule info as well
        const dayText = DAY_LABEL[slot.day] ?? slot.day;
        const startFormatted = moment(startTime).format(translate('timeFormat.Time'));
        const endFormatted = moment(endTime).format(translate('timeFormat.Time'));
        scheduleStringsFormated.push(translate('timeFormat.TimeFrame', {
          dayText: dayText,
          startFormatted: startFormatted,
          endFormatted: endFormatted,
        }));
        return totalHours + duration.asHours();
      }, 0);
      hoursPerWeek = Math.floor(hoursPerWeek);
      weeklyRate = hoursPerWeek*hourlyRate;
      numShifts = weeklySlots.length;
      hoursPerWeekString = translate('jobBoard.SalaryDetails.HoursPerWeek', {hoursPerWeek: hoursPerWeek});
      shifts = translate('jobBoard.SalaryDetails.Shifts', {numShifts: numShifts});
      salaryInfo = translate('jobBoard.SalaryDetails.SalaryInfo', {
        payPerHour: payPerHour,
        hoursPerWeekString: hoursPerWeekString,
        shifts: shifts,
      });
      break;
    case 'LIVEIN_EVENT':
      const hours = 8;
      const days = 7;
      hoursPerWeek = hours*days;
      weeklyRate = hoursPerWeek*hourlyRate;
      numShifts = 7;
      hoursPerWeekString = translate('jobBoard.SalaryDetails.HoursPerWeek', {hoursPerWeek: hoursPerWeek});
      break;
    default:
      break;
  }
  const formatedWeeklyRate = formatCurrency(weeklyRate, currency, 'en-CA');
  const payPerWeekString = translate('jobBoard.SalaryDetails.PayPerWeek', {
    currency: currency,
    formatedWeeklyRate: formatedWeeklyRate,
  });
  return {
    payPerHour: payPerHour,
    scheduleStringsFormated: scheduleStringsFormated,
    hoursPerWeekString: hoursPerWeekString,
    numShifts: numShifts,
    shifts: shifts,
    salaryInfo: salaryInfo,
    payPerWeekString: payPerWeekString,
    recurrenceType: recurrenceType,
  };
};

export {
  parseJobData,
};
